"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var affiliateModalClasses = (0, _cssClassesHelper.getBEMClasses)('affiliate-modal');
var AffiliateModal = function AffiliateModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var handleSubmit = props.handleSubmit,
    submitting = props.submitting;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: t("Create or Edit Affiliate Tag"),
    onCancel: function onCancel() {
      props.close();
    },
    close: props.close,
    customClass: affiliateModalClasses('ap-modal')
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: affiliateModalClasses('form')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: affiliateModalClasses('input-wraper')
  }, /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    customClass: affiliateModalClasses(),
    type: "text",
    name: "tag"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: affiliateModalClasses('footer')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    customClass: affiliateModalClasses()
  }, submitting ? t("Submitting...") : t("Update")))));
};
AffiliateModal.propTypes = {
  submitting: _propTypes["default"].bool.isRequired,
  close: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = AffiliateModal;